module.exports = __webpack_public_path__ + "static/media/method1.67a4fa1b.png";